"use client";

import { Circle } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const trustItems = [
  "Agriculture",
  "Construction",
  "Schools and Institutions",
  "Manufacturing",
  "Commercial businesses",
  "Homes & Estates",
];

export default function TrustStrip() {
  return (
    <section className="w-full">
      <div className="w-full relative bg-black">

        {/* Left fade */}
        <div
          className="absolute left-0 top-0 h-full w-20 md:w-40 z-10 pointer-events-none"
          style={{ background: "linear-gradient(to right, #181818, transparent)" }}
        />

        {/* Right fade */}
        <div
          className="absolute right-0 top-0 h-full w-20 md:w-40 z-10 pointer-events-none"
          style={{ background: "linear-gradient(to left, #181818, transparent)" }}
        />

        <Swiper
          modules={[Autoplay]}
          slidesPerView="auto"
          spaceBetween={56}
          loop={true}
          autoplay={{ delay: 0, disableOnInteraction: false }}
          speed={3000}
          allowTouchMove={false}
          className="py-6"
        >
          {[...trustItems, ...trustItems].map((item, i) => (
            <SwiperSlide key={i} className="w-auto!">
              <span className="flex items-center py-4 md:py-4 gap-3 text-sm md:text-lg text-white/70 tracking-wide whitespace-nowrap">
                <Circle className="w-3 h-3 fill-primary text-transparent shrink-0" />
                {item}
              </span>
            </SwiperSlide>
          ))}
        </Swiper>
        
      </div>
    </section>
  );
}